export class ButtonDefinition {
    id = "";
    title = "";
    isSuccess = false;
    icon = "";
    style = "";

    constructor(id: string, title: string, isSuccess: boolean, icon: string, style = "", public severity: "success" | "info" | "warn" | "danger" | "help" | "primary" | "secondary" | "contrast" = null) {
        this.id = id;
        this.title = title;
        this.isSuccess = isSuccess;
        this.icon = icon;
        this.style = style;
    }
}
